import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import UserContainer from '../../containers/User';
import FormTypeToSelect from '../form/FormTypeToSelect';

const styles = () => {
	return {};
};

class UserPicker extends PureComponent {
	state = {
		value: '',
	};

	componentDidMount() {
		if (_.isEmpty(this.props.users)) {
			this.props.searchUsers({
				includeHidden: this.props.includeHidden,
			});
		} else {
			this.formatTheUsers();
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { users } = this.props;

		if (!_.isEmpty(users) && prevProps.users !== users) {
			this.formatTheUsers();
		}
	}

	formatTheUsers = () => {
		const {
			users,
			whoToShow,
			includeTermUsers,
			companyDepartmentIds,
			userIdsToShow,
			userIdsNotToShow,
			useGeoTabNameAsValue,
		} = this.props;

		//	const formattedUsers = _.sortBy(this.props.users, 'lastName').map(user => {
		let formattedUsers = [];

		users.forEach((user) => {
			const { userId, firstName, lastName, role, geoTabName, isHidden } = user;

			if (!includeTermUsers && isHidden) {
				return;
			}

			if (whoToShow === 'driversOnly') {
				if (role !== 'driver') {
					return;
				}
			} else if (whoToShow === 'nonDriversOnly') {
				if (role === 'driver' || role === 'emailGroup') {
					return;
				}
			} else if (whoToShow === 'nonDriversOnlyWithEmailGroups') {
				if (role === 'driver') {
					return;
				}
			} else if (whoToShow === 'driversAndNonDriversOnly') {
				if (role === 'emailGroup') {
					return;
				}
			}

			if (!_.isEmpty(companyDepartmentIds)) {
				if (_.isEmpty(user.companyDepartmentIds)) {
					return;
				}

				const deptMap = {};
				companyDepartmentIds.forEach((id) => {
					deptMap[id] = true;
				});

				let hasMatch = false;

				user.companyDepartmentIds.forEach((id) => {
					if (deptMap[id]) {
						hasMatch = true;
					}
				});

				if (!hasMatch) {
					return;
				}
			}

			if (!_.isEmpty(userIdsToShow)) {
				if (!_.includes(userIdsToShow, userId)) {
					return;
				}
			}

			if (!_.isEmpty(userIdsNotToShow)) {
				if (_.includes(userIdsNotToShow, userId)) {
					return;
				}
			}

			let label = `${firstName} ${lastName}`;
			if (!lastName) {
				label = `${firstName}`;
			} else if (!firstName) {
				label = `${lastName}`;
			}

			if (geoTabName) {
				label = label + ` (${geoTabName})`;
			}

			if (isHidden) {
				label = label + ` (terminated)`;
			}

			let value = userId;
			if (useGeoTabNameAsValue) {
				if (!geoTabName) {
					return;
				}
				value = geoTabName;
			}

			formattedUsers.push({
				value,
				label,
			});
		});
		formattedUsers = _.sortBy(formattedUsers, 'label');

		this.setState({ formattedUsers });
	};

	render() {
		const { classes } = this.props;
		const { formattedUsers } = this.state;

		if (_.isEmpty(formattedUsers)) {
			return <div className={classes.fetching}>Fetching users...</div>;
		}

		return <FormTypeToSelect {...this.props} options={formattedUsers} />;
	}
}

UserPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	helpText: PropTypes.string,
	placeholder: PropTypes.string,

	selectMultiple: PropTypes.bool,
	whoToShow: PropTypes.string,
	includeTermUsers: PropTypes.bool,
	companyDepartmentIds: PropTypes.array,
	userIdsToShow: PropTypes.array,
	userIdsNotToShow: PropTypes.array,

	useGeoTabNameAsValue: PropTypes.bool,
	includeHidden: PropTypes.bool,

	searchUsers: PropTypes.func,
	users: PropTypes.array,
};

UserPicker.defaultProps = {
	label: 'Employee',
	placeholder: 'Search for employee',
	whoToShow: 'all',
	selectMultiple: false,
};

export default _.flow([withStyles(styles), UserContainer])(UserPicker);
